import {request} from "@/utils/request";

// 获取高中学校名
export const GetHighSchoolRank = (params) => {
  return request({
    method: "get",
    url: `/api/HighSchoolRank/Get`,
    params,
  });
};
